import React from 'react';
import { Table, Loader } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer } from 'react-toastify';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

const NoDataMessage = () => <p>Nema arhiviranih implementacija odabranog smjera (studijskog programa).</p>;

export default class ArchivedSPImpl extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        const { data } = this.props;
        if (!this.props.loaded) return (<div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /><br /></div>);
        return (
            <div>
                {data.length ?
                    <Table celled selectable compact >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>
                                          Naziv implementacije smjera (studijskog programa)
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body> {data.map((el, index) =>
                            (<Table.Row key={index}>
                                <Table.Cell verticalAlign="middle">
                                    {el.name}
                                </Table.Cell>
                            </Table.Row>))}
                        </Table.Body>
                    </Table>
                    : <NoDataMessage />
                }

                <ToastContainer hideProgressBar />

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Admin/CreateStudyProgram/ArchivedSPImpl.js